import { Pipe, PipeTransform } from '@angular/core';
import { InstallationJobProducedPluginService } from './job-produced.service';

@Pipe({
    name: 'joblabel',
    standalone: false
})
export class JobLabelPipe implements PipeTransform {
  public labelValues: any[];

  constructor(private service: InstallationJobProducedPluginService) {
    this.labelValues = this.service.getLabelValues();
  }

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.labelValues);
  }
}
